<template>
    <div :class="{increasing:isIncreasing}" >
        <slot/>
    </div>
</template>

<script lang="ts">
 import { Vue, Options, Prop, Watch} from 'vue-property-decorator';
 
export default class ProgressIndicator extends Vue
{
    @Prop({default:200}) public delay!: number;
    public isIncreasing = false;
    
    private progressTimeout = 0;
    public setProgressing (value: boolean)
    {
        clearTimeout(this.progressTimeout);

        if (value) {
            this.isIncreasing=true;
        }
        else {
            if (this.delay>0) {
                this.progressTimeout=setTimeout(()=>{
                    this.isIncreasing=false;
                },this.delay)
            }
            else {
                this.isIncreasing=false;
            }
        }
    }
  
}
</script>
